import { useMutation } from 'react-query';

import api from '@root/api/newApi';

export default function useCreateDocument() {
  return useMutation(
    (data) => api.googleDocs.createDocument(data),
  );
}
